if (!customElements.get('lc-factory-fitment')) {
  customElements.define('lc-factory-fitment', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.model = this.querySelector('[data-factory-model]');
      this.year = this.querySelector('[data-factory-year]');
      this.catalog = JSON.parse(this.querySelector('[data-factory-models]').textContent);
      this.placeholder = this.year.options[0].textContent;
      this.summary = this.closest('[data-lc-factory]').querySelector('[data-factory-summary]');
      this.model.addEventListener('change', () => this.updateYears());
      this.year.addEventListener('change', () => this.updateSummary());
      const params = new URLSearchParams(location.search);
      const requested = params.get('lc_model');
      const canonical = this.catalog.models[requested] ? requested : this.catalog.aliases?.[requested];
      if (canonical) this.model.value = canonical;
      this.updateYears();
      if ([...this.year.options].some(option => option.value === params.get('lc_year'))) this.year.value = params.get('lc_year');
      this.updateSummary();
    }
    updateYears() {
      const previous = this.year.value;
      const years = this.catalog.models[this.model.value] || [];
      this.year.replaceChildren(new Option(this.placeholder, ''), ...years.map(year => new Option(year, year)));
      if (years.includes(previous)) this.year.value = previous;
      this.updateSummary();
    }
    updateSummary() {
      this.summary.textContent = this.model.value && this.year.value ? `KTM ${this.model.value} · ${this.year.value}` : this.summary.dataset.empty;
    }
  });
}

customElements.whenDefined('variant-selects').then(() => {
  if (customElements.get('lc-factory-variants')) return;
  const ThemeVariants = customElements.get('variant-selects');
  customElements.define('lc-factory-variants', class extends ThemeVariants {
    constructor() {
      super();
      this.other = [];
    }
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-factory-variants]').textContent);
      super.connectedCallback();
    }
    renderVariantInfo() {
      this.currentVariant = this.variants.find(variant => variant.options.every((value, index) => value === this.options[index]));
      if (!this.currentVariant) {
        this.toggleAddButton(true);
        this.setUnavailable();
        return;
      }
      this.updateVariantInput();
      const price = this.querySelector(`[data-factory-price="${this.currentVariant.id}"]`);
      document.getElementById(`price-${this.dataset.section}`).replaceChildren(price.content.cloneNode(true));
      this.updateURL();
      this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);
      this.updateMedia();
    }
    updateURL() {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', this.currentVariant.id);
      url.searchParams.delete('option_values');
      window.history.replaceState({}, '', url);
    }
  });
});
